import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import SalesPeopleGrid from '@sophocles/views/sales/components/SalesPeopleGrid';

function SalesPeopleView() {
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: t('warehouse.sales', 'Sales'), to: '/sales/orders' },
    { label: t('warehouse.people', 'People') },
  ];

  return (
    <AppNav loading={false} page="sales_people" notFullHeight flex>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        <TitleBar breadcrumbs={breadcrumbs} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            px: 'var(--page-px)',
            pb: 'var(--page-py)',
          }}
        >
          <SalesPeopleGrid />
        </Box>
      </Box>
    </AppNav>
  );
}

export default SalesPeopleView;
